import React from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../../utils/responsive-query';

import { ReactComponent as TwitterLogo } from '../../../assets/icons/social-media/twitter-circle.svg';
import { ReactComponent as LinkedinLogo } from '../../../assets/icons/social-media/linkedin-circle.svg';
import { ReactComponent as InstagramLogo } from '../../../assets/icons/social-media/instagram-circle.svg';
import { ReactComponent as Chevron } from '../../../assets/icons/logo/chevron.svg';

/*
import DriverTCsPDF from '../../../assets/documents/Paua-Driver-terms-and-conditions-6-6-2024.pdf';
import BusinessTCsPDF from '../../../assets/documents/Paua-Business-Terms-5-march-2024.pdf';
import ModernSlaveryPDF from '../../../assets/documents/Paua-Modern-Slavery-and-Human-Trafficking-Policy-2022.pdf';
import DriverHandbookPDF from '../../../assets/documents/Paua-driver-handbook-v0.3-16-8-22-SC.pdf';
*/
export default function Footer() {
	let isMobile = useMediaQuery('(max-width: 1023px)');

	return (
		<footer className='footer px-8 lg:px-0 pb-20 py-10 lg:py-12 font-paua bg-paua-deep-purple text-sm bottom-0 w-screen '>
			<div className='flex flex-col container mx-auto lg:pb-10'>
				<div className='flex justify-between flex-col lg:items-center lg:flex-row lg:w-11/12 lg:mx-auto'>
					<div className='flex flex-col'>
						<div className='mb-2'>
							<Chevron width={60} height={60} />
						</div>
						<div className='mt-6'>
							<p className='text-white'>
								92 Station Road
								<br />
								Clacton On Sea
								<br />
								Essex
								<br />
								CO15 1SG
								<br />
								United Kingdom
							</p>
						</div>
						<div className='mt-16'>
							<p className='text-white text-l font-semibold mb-3'>
								Member of the AFP
							</p>
							<a href='https://www.theafp.co.uk/' rel='noreferrer' target='_blank'>
								<img
									src='../../images/logos/afp.png'
									style={{ 'max-height': '80px' }}
									alt='Paua is member of the Association of Fleet Professionals'
								/>
							</a>
						</div>
					</div>
					<div className='mt-4 pt-4 lg:pt-10 flex flex-col text-white'>
						<h1 className='text-xl font-semibold mb-3'>Get in touch</h1>
						<div>
							<p className='leading-5'>
								Company number: 12145853
								<br />
								VAT number: 387 4960 40
								<br />
							</p>
						</div>
						<div className='my-4'>
							<a href='mailto:info@pauatech.com' type='email'>
								info@pauatech.com
							</a>
						</div>
						<div className='my-4 lg:mb-0 lg:mt-4 flex flex-row lg:w-1/3 lg:justify-between'>
							<div className='mr-2'>
								<a
									href='https://www.linkedin.com/company/pauatech/'
									rel='noreferrer'
									target='_blank'
								>
									<LinkedinLogo
										width='34'
										height='34'
										className='fill-paua-pink'
									/>
								</a>
							</div>
							<div className='mr-2'>
								<a
									href='https://www.instagram.com/pauaev/'
									norel='noreferrer'
									target='_blank'
									rel='noreferrer'
								>
									<InstagramLogo
										width='34'
										height='34'
										className='fill-paua-pink'
									/>
								</a>
							</div>
							<div>
								<a
									href='https://twitter.com/evpaua'
									rel='noreferrer'
									target='_blank'
								>
									<TwitterLogo
										width='34'
										height='34'
										className='fill-paua-pink'
									/>
								</a>
							</div>
						</div>{' '}
					</div>
				</div>
				<div className='flex justify-between flex-col lg:flex-row lg:w-11/12  lg:items-end h-full lg:mx-auto text-paua-faded-purple mt-10 xSmallText'>
					{isMobile ? (
						<div className='flex flex-col 2xl:flex-row justify-end xl:justify-between mt-2 lg:mt-0'>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='http://pauatech-25525850.hubspotpagebuilder.eu/paua-referrals-1-1-0?hs_preview=EGwTfaZi-105163045579'
									target='_blank'
									rel='noreferrer'
								>
									Jobs
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/download-paua'
									target='_blank'
									rel='noreferrer'
								>
									Download the app
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/paua-driver-terms'
									target='_blank'
									rel='noreferrer'
								>
									Driver Terms and Conditions
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/paua-business-terms'
									target='_blank'
									rel='noreferrer'
								>
									Paua Business Terms and Conditions
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/privacy-policy'
									target='_blank'
									rel='noreferrer'
								>
									Privacy Policy
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/cookie-policy'
									target='_blank'
									rel='noreferrer'
								>
									Cookie Policy
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/paua-modern-slavery-statement'
									target='_blank'
									rel='noreferrer'
								>
									Modern Slavery and Human Trafficking Policy
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/paua-driver-handbook'
									target='_blank'
									rel='noreferrer'
								>
									Driver Handbook
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://status.pauatech.com/'
									target='_blank'
									rel='noreferrer'
								>
									App Status
								</a>
							</div>
							<div className='mt-2 lg:mt-0 lg:ml-4'>
								<a
									className='underline font-light'
									href='https://www.paua.com/pricing#pricing-faqs'
									target='_blank'
									rel='noreferrer'
								>
									FAQs
								</a>
							</div>
							<div className='mt-2 lg:mt-0 mb-3  lg:ml-4'>
								<Link
									to='https://www.paua.com/contact-us'
									className='underline font-light'
									target='_blank'
									rel='noreferrer'
								>
									Contact us
								</Link>
							</div>
						</div>
					) : null}
					<div>
						<p className='text-sm pt-2 lg:pt-0'>
							© Paua Tech Limited. All rights reserved.
						</p>
					</div>
					<div>
						<p className='text-sm pt-2 lg:pt-0'>
							Paua aim to power 1.5million zero emissions miles per week by the end of
							2024
						</p>
					</div>

					{!isMobile ? (
						<div className='flex justify-end pb-1 pt-4 text-xs'>
							<div className='w-10/12 pl-8 flex flex-col justify-end underline-offset-2'>
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://www.paua.com/jobs'
										target='_blank'
										rel='noreferrer'
									>
										Jobs
									</a>
								</div>
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://www.paua.com/download-paua'
										target='_blank'
										rel='noreferrer'
									>
										Download the app
									</a>
								</div>
								<div className='mt-3'>
									<a
										className='underline font-light'
										href='https://www.paua.com/paua-driver-terms'
										target='_blank'
										rel='noreferrer'
									>
										Driver Terms and Conditions
									</a>
								</div>
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://www.paua.com/paua-business-terms'
										target='_blank'
										rel='noreferrer'
									>
										Paua Business Terms and Conditions
									</a>
								</div>
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://www.paua.com/privacy-policy'
										target='_blank'
										rel='noreferrer'
									>
										Privacy Policy
									</a>
								</div>{' '}
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://www.paua.com/cookie-policy'
										target='_blank'
										rel='noreferrer'
									>
										Cookie Policy
									</a>
								</div>
								<div className='mt-3 leading-5'>
									<a
										className='underline font-light'
										href='https://www.paua.com/paua-modern-slavery-statement'
										target='_blank'
										rel='noreferrer'
									>
										Modern Slavery and Human Trafficking Policy
									</a>
								</div>
								<div className='mt-3'>
									<a
										className='underline font-light'
										href='https://www.paua.com/paua-driver-handbook'
										target='_blank'
										rel='noreferrer'
									>
										Driver Handbook
									</a>
								</div>
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://status.pauatech.com/'
										target='_blank'
										rel='noreferrer'
									>
										App Status
									</a>
								</div>
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://www.paua.com/pricing#pricing-faqs'
										target='_blank'
										rel='noreferrer'
									>
										FAQs
									</a>
								</div>
								<div className='mt-3 '>
									<a
										className='underline font-light'
										href='https://www.paua.com/contact-us'
										target='_blank'
										rel='noreferrer'
									>
										Contact us
									</a>
								</div>
							</div>
						</div>
					) : null}
				</div>
			</div>
		</footer>
	);
}
